export const BUILDER_STORAGE_KEY = 'builder-pois';
export const LONG_PRESS_THRESHOLD = 300;

export enum BuilderEventBus {
  toggle = 'builderToggle',
}
